import gql from 'graphql-tag';

import { UserPoints, userPointsFragment } from '../fragments/points';

export const pointQuery = gql`
    query PointQuery {
        user {
            points {
                ...UserPoints
            }
        }
    }
    ${userPointsFragment}
`;

interface User {
    __typename: 'User';
    points: UserPoints;
}

export interface PointQueryResponse {
    __typename: 'Query';
    user: User;
}
